export default "__VITE_ASSET__C1tTUtX2__"